import React from 'react';
import {connect} from 'react-redux';
import {programStore} from '../../../../../redux/entities/inventory/program';
import {CommonState} from '../../../../../redux';
import {bindActionCreators, Dispatch} from 'redux';
import {EntityManagementModal} from '../../../../../components/util/EntityManagementModal/EntityManagementModal';

interface Props {
  opened: boolean;
  onClose: () => void;
}

type ConnectedProps = Props & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const ProgramModal: React.FC<ConnectedProps> = ({opened, onClose, unarchivedPrograms, archivedPrograms, actions}) => {
  return (
    <EntityManagementModal
      opened={opened}
      onClose={onClose}
      title="Manage Programs"
      entityName="Program"
      unarchivedEntities={unarchivedPrograms}
      archivedEntities={archivedPrograms}
      actions={actions}
    />
  );
};

const mapStateToProps = (state: CommonState) => ({
  unarchivedPrograms: programStore.selectors.unarchived(state),
  archivedPrograms: programStore.selectors.archived(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators({
    upsert: programStore.actions.upsert,
    archive: programStore.actions.archive,
    restore: programStore.actions.restore
  }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ProgramModal);
